__webpack_require__.p = "https://static.age.awaze.com/search-mfe/d977e17/_next/";